'use strict';

module.exports = function isPropertyKey(argument) {
	return typeof argument === 'string' || typeof argument === 'symbol';
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/es-abstract/helpers/isPropertyKey.js
 ** module id = 81
 ** module chunks = 0
 **/